import React from "react";
import { Screen }  from '../components';
import { getItem } from '../Storage';
import { Player }  from '@lottiefiles/react-lottie-player';

// Full-screen end state for a session that is over. It states the outcome and nothing else:
// care-web cannot tell which path brought the user here (partner link or direct sign-in), so
// it gives no instruction on how to start again.
//
// variant: 'expired' (default) for a token that has run out, 'invalid' for a session link the
// API does not recognise.
export default class SessionExpired extends React.Component {

  render() {
    let partner  = getItem('partner');
    let logo_url = partner && partner.logo_url ? partner.logo_url : '';
    let message  = this.props.variant === 'invalid' ? 'Your Session Link Is Invalid' : 'Your Session Has Expired';

    return <Screen>
      <div style={{ height: 100 }} />
      <div className='flex-container-column' style={{ alignItems: 'center' }}>
        { logo_url ? <img src={ logo_url } alt="" style={{ height: 40, width: 'auto', marginBottom: 30 }} /> : null }
        <Player autoplay loop src={ require('../animations/session-ended.json') } style={{ height: '50px', width: '50px', marginTop: -15, marginBottom: -15 }} />
        <div style={{ marginTop: 15, fontSize: 15, fontWeight: 'bold', color: '#4c4c4c' }}>{ message }</div>
      </div>
    </Screen>
  }

}
